import _ from "lodash";
import {DATAFLOW_TYPE_NORMAL} from "./dataflow";

export function isDateValid(validFrom, validTo) {
  return !validFrom || !validTo || validFrom <= validTo;
}

export function isIDValidWithHelp(t, id) {

  if (/[^0-9a-z_-]/gi.test(id)) {
    return ({
      valid: false,
      help: t('validators.id.containsUnallowedChars')
    });
  } else {
    return ({valid: true});
  }
}

export function isVersionValidWithHelp(t, version) {

  const MAX_LENGTH = 10;

  if (!version || version.length === 0) {
    return ({valid: true});
  } else if (version.length > 10) { // max length 10
    return ({
      valid: false,
      help: t('validators.version.exceddsMaxLength', {maxLength: MAX_LENGTH})
    });
  } else if (version.indexOf(".") < 0) { // must contain "."
    return ({valid: false, help: t('validators.version.notContainsDot')});
  } else if (version.substr(version.length - 1) === ".") { // must not end with .
    return ({valid: false, help: t('validators.version.endsWithDot')});
  } else {

    const arr = version.split(".");

    if (arr.length > 3) { // max version depth is x.y.z
      return ({valid: false, help: t('validators.version.exceddsMaxDepth')});
    } else if (
      arr.filter(number => number === "0" || /^[1-9]([0-9]*)$/.test(number)).length !== arr.length
    ) { // each x, y, z must be 0 or a number
      return ({valid: false, help: t('validators.version.componentIsInvalid')});
    } else {
      return ({valid: true});
    }
  }
}

export function isDictionaryValid(dictionary) {
  return dictionary !== undefined && dictionary !== null &&
    _(dictionary)
      .pickBy(val => val !== undefined && val !== null && val.length > 0)
      .keys()
      .value().length > 0
}

export function isArtefactValid(artefact) {
  return !(
    artefact === null || artefact === undefined ||
    artefact.id === null || artefact.id.length === 0 ||
    artefact.agencyID === null || artefact.agencyID.length === 0 ||
    artefact.version === null || artefact.version.length === 0 ||
    (artefact.dsd === null && artefact.dataflowType === DATAFLOW_TYPE_NORMAL) ||
    artefact.msd === null ||
    !isIDValidWithHelp(f => f, artefact.id).valid ||
    !isVersionValidWithHelp(f => f, artefact.version).valid ||
    !isDateValid(artefact.validFrom, artefact.validTo) ||
    !isDictionaryValid(artefact.name)
  );
}

export function isItemValid(item) {
  return !(
    item === null ||
    item.id === null || item.id.length === 0 ||
    !isIDValidWithHelp(f => f, item.id).valid ||
    !isDictionaryValid(item.name)
  );
}

export function isCloneDestTripletValid(cloneDestTriplet) {
  return !(
    !cloneDestTriplet ||
    cloneDestTriplet.id === null || cloneDestTriplet.id.length === 0 ||
    cloneDestTriplet.agencyID === null || cloneDestTriplet.agencyID.length === 0 ||
    cloneDestTriplet.version === null || cloneDestTriplet.version.length === 0 ||
    !isVersionValidWithHelp(f => f, cloneDestTriplet.version).valid
  );
}

export function isExportDestinationValid(exportDestination) {
  return (
    exportDestination &&
    exportDestination.endpoint &&
    exportDestination.username &&
    exportDestination.id &&
    exportDestination.agencyID &&
    exportDestination.version &&
    isVersionValidWithHelp(f => f, exportDestination.version).valid
  );
}

export function isYearValid(year) {
  return !year || (
    !isNaN(year) &&
    Number(year) > 1000 &&
    Number(year) < 9999
  );
};

export function isHierarchicalCodelistDefinitionValid(hcl) {
  let invalidHierarchies = (hcl.hierarchies || []).filter(h => (h.hierarchicalCodes || []).length === 0);
  return invalidHierarchies.length === 0;
};

export function isHierarchyArtefactValid(hierarchy) {
  return !(
    hierarchy === null || hierarchy === undefined ||
    hierarchy.id === null || hierarchy.id.length === 0 ||
    hierarchy.type === null || hierarchy.type.length === 0 ||
    !isIDValidWithHelp(f => f, hierarchy.id).valid ||
    !isDictionaryValid(hierarchy.name)
  );
};

export const isExtensionInvalid = (fileName, extensions) => {
  const splitName = fileName.split(".");
  const ext = splitName[splitName.length - 1];
  return !extensions.includes(`.${ext}`);
}